<script lang="js">
import axios from "axios";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      applicationNumber: "",
      password: "",
      loading: false,
      errorMessage: "",
    };
  },
  methods: {
    async login() {
      this.loading = true;
      this.errorMessage = "";

      try {
        const apiUrl = `${process.env.VUE_APP_API_BASE_URL}/login`;

        const response = await axios.post(apiUrl,
          {
            username: this.applicationNumber,
            password: this.password,
          },
          {
            headers: {
              Authorization: "Bearer fcpportals@new",
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.Message === "OK") {
          // Store user data in localStorage (Vuex)
          this.$store.commit("setUser", response.data.Data.biodata_info); // Store user globally
          // localStorage.setItem("user", JSON.stringify(response.data.Data));

          console.log(response.data);

        Swal.fire({
          title: "Success!",
          text: "Login successful!",
          icon: "success"
        });
          // Redirect to dashboard or another page
          this.$router.push("/app");
        } else {
          this.errorMessage = "Invalid login credentials.";
        }
      } catch (error) {
        this.errorMessage = "Login failed. Please try again.";
        console.error("Login Error:", error);
      } finally {
        this.loading = false;
      }
    },
  },
  components: {},
};
</script>

<template>
  <div class="container-fluid bg-body-tertiary">
    <div class="d-flex align-items-center py-4 vh-100">
      <main class="form-signin w-100 m-auto">
        <form @submit.prevent="login">
          <RouterLink to="/app">
            <img
              src="../assets/logo.png"
              class="mb-4"
              alt=""
              width="96.26"
              height="70"
            />
          </RouterLink>
          <h1 class="h3 mb-3 fw-bold text-uppercase">FCP Login</h1>
          <p>Please fill out the following fields to login</p>

          <div
            v-if="errorMessage"
            class="alert alert-danger alert-dismissible fade show mt-3 d-flex justify-content-between"
            role="alert"
          >
            <div>
              <i class="bi bi-exclamation-triangle-fill me-2"></i>
              {{ errorMessage }}
            </div>

            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>

          <div class="form-floating">
            <input
              type="text"
              class="form-control border border-bottom-0 rounded-bottom-0"
              v-model="applicationNumber"
              id="floatingInput"
              placeholder="FC24123456"
              required
            />
            <label for="floatingInput">Application Number</label>
          </div>
          <div class="form-floating">
            <input
              type="password"
              class="form-control"
              id="floatingPassword"
              v-model="password"
              placeholder="Password"
              required
            />
            <label for="floatingPassword">Password</label>
          </div>

          <div class="form-check text-start my-3">
            <input
              class="form-check-input"
              type="checkbox"
              value="remember-me"
              id="flexCheckDefault"
            />
            <label class="form-check-label" for="flexCheckDefault">
              Remember me
            </label>
          </div>

          <div class="d-grid gap-2 col-6 mx-auto mb-5">
            <button class="btn btn-success" type="submit" :disabled="loading">
              {{ loading ? "Signing In..." : "Sign In" }}
            </button>
            <!-- <RouterLink class="btn btn-success" to="/app"></RouterLink> -->
            <RouterLink class="btn btn-danger" to="/app/apply">
              Sign up
            </RouterLink>
          </div>

          <hr />

          <p class="mt-3 mb-3 text-body-secondary">© 2022–2025</p>
        </form>
      </main>
    </div>
  </div>
</template>

<style scoped>
html,
body {
  height: 100%;
}

.form-signin {
  max-width: 530px;
  padding: 1rem;
}

.form-signin .form-floating:focus-within {
  z-index: 2;
}

.form-signin input[type="number"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
